export enum UnitType {
  DISTANCE = "distance",
  DISTANCE_MIN = "distance/min",
  SPEED = "speed",
  ACTION_DISTANCE = "action_distance",
  POWER = "power",
  HR = "hr",
  ACCELERATION = "acceleration",
  JUMP_DISTANCE = "jump_distance",
}

export enum ActionSettingType {
  RUN = "run",
  ACCELERATION = "acceleration",
  DECELERATION = "deceleration",
  JUMP = "jump",
  DIVE = "dive",
  COD = "cod",
}

export const SquareUnit: { [key: string]: string } = {
  "m/s^2": "m/s²",
  "yd/s^2": "yd/s²",
  "ft/s^2": "ft/s²",
}
